// extracted by mini-css-extract-plugin
export default {"footer":"G-z","footerContainer":"H-z"};